export default "__VITE_ASSET__oC3QC6yT__"